import React from 'react';
import './PartnersPage.css';
import Footer from './Footer';
import HeroSection from './HeroSection';
import Seo from './Seo';

// Each partner: logo lives in webapp/public/. Keep descriptions to 1-2 sentences.
const partners = [
  {
    name: 'PX5 RTOS',
    logo: '/px5-logo.svg',
    url: 'https://px5rtos.com',
    description:
      'Headquartered in San Diego, California, PX5 provides the industry’s most '
      + 'advanced runtime solutions for deeply embedded applications. With decades of '
      + 'domain expertise, including having previously created the ThreadX and Nucleus '
      + 'real-time operating systems, PX5 is pushing the boundaries of how industry '
      + 'standards can improve the safety, security, and portability of applications '
      + 'running on microprocessor-based systems. The industrial-grade PX5 RTOS is an '
      + 'advanced, fifth-generation RTOS designed for the most demanding embedded '
      + 'applications, featuring a native implementation of the POSIX pthreads API and '
      + 'best-of-class size and performance.',
  },
  {
    name: 'wolfSSL',
    logo: '/wolfssl-partner-logo.png',
    url: 'https://www.wolfssl.com',
    description:
      'wolfSSL provides embedded security software built for resource-constrained '
      + 'environments with limited memory, processing power, and storage. Our '
      + 'lightweight, highly optimized solutions protect communications, cryptography, '
      + 'and firmware without adding unnecessary resource overhead. Designed for '
      + 'portability across embedded platforms, wolfSSL helps organizations build '
      + 'secure, high-performance products while meeting demanding security and '
      + 'industry requirements.',
  },
  {
    name: 'OnMCU',
    logo: '/onmcu-logo.svg',
    url: 'https://www.onmcu.com',
    description:
      'OnMCU gives embedded teams cloud access to real MCU hardware for '
      + 'CI/CD-integrated testing, without a physical lab. Firmware runs on actual '
      + 'silicon on every commit, not just before release.',
  },
];

const PartnersPage = () => (
  <div className="partners-page">
    <Seo
      title="Partners – MemBrowse"
      description="MemBrowse partners with leading embedded runtime and security companies to bring memory observability to firmware teams."
      path="/partners"
    />

    {/* Hero Section */}
    <HeroSection
      title="Our Partners"
      subtitle="Trusted partnerships across the embedded software stack"
    />

    {/* Partners Section */}
    <section className="partners-page-section">
      <div className="partners-page-container">
        {partners.map((partner) => (
          <div className="partner-showcase-card" key={partner.name}>
            <a
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              className="partner-showcase-logo-link"
              aria-label={partner.name}
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="partner-showcase-logo"
              />
            </a>
            <p className="partner-showcase-description">{partner.description}</p>
          </div>
        ))}
      </div>
    </section>

    <Footer />
  </div>
);

export default PartnersPage;
